import { Pipe, PipeTransform } from '@angular/core';
import { FinancialLifeCycleItemCategory } from '../../interfaces/dashboard';

@Pipe({
  name: 'financialLifecycleCategory'
})
export class FinancialLifecycleCategoryPipe implements PipeTransform {

  transform(value: FinancialLifeCycleItemCategory): string {
    const categories = {
      [FinancialLifeCycleItemCategory.ATIVO_REGULAR]: 'Ativo Regular',
      [FinancialLifeCycleItemCategory.CHURN]: 'Churn',
      [FinancialLifeCycleItemCategory.NOVO_APOSTADOR]: 'Novo Apostador',
      [FinancialLifeCycleItemCategory.REATIVACAO]: 'Reativação',
    };

    return categories[value];
  }

}
